
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-shankar-ias",
      function () {
        return require("private-next-pages/why-shankar-ias/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-shankar-ias"])
      });
    }
  